var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-data",staticStyle:{"height":"280px"}},[_vm._m(0),_c('div',{ref:"memberData",staticClass:"member-data"}),_c('div',{staticClass:"member-num"},[_vm._v("人数："+_vm._s(_vm.sum)+"人")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"little-box"},[_c('div',{staticClass:"little-box_title"},[_vm._v("人员资质")]),_c('div',[_vm._v("更多")])])
}]

export { render, staticRenderFns }